import { Button } from '@cian/ui-kit/button';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ListingToggleButton.css';
import { DESKTOP_SIDEBAR_WIDTH } from '../../../common/constants/desktopSidebar';
import { KEEP_OFFER_PREVIEW_OPEN_ATTR } from '../../../common/constants/offerPreview';

const SIDEBAR_EDGE_GAP = 16;
const OPENED_BUTTON_OFFSET = DESKTOP_SIDEBAR_WIDTH + SIDEBAR_EDGE_GAP;

interface IListingToggleButtonProps {
  isListingVisible: boolean;
  onClick: () => void;
  className?: string;
}

export const ListingToggleButton: React.FC<IListingToggleButtonProps> = ({ isListingVisible, onClick, className }) => {
  const iconExtraClassName = isListingVisible ? styles['caret-left'] : styles['caret-right'];

  return (
    <div
      data-testid="ListingToggleButton"
      {...{ [KEEP_OFFER_PREVIEW_OPEN_ATTR]: '' }}
      className={cn(styles['root'], className)}
      style={{ transform: isListingVisible ? `translateX(${OPENED_BUTTON_OFFSET}px)` : undefined }}
    >
      <Button
        theme="fill_white_primary"
        size="M"
        beforeIcon={
          <div className={cn(styles['icon-wrapper'], iconExtraClassName)}>
            <IconActionChevronLeft16 color="icon-main-default" />
          </div>
        }
        onClick={onClick}
      >
        {isListingVisible ? 'Раскрыть карту' : 'Показать список'}
      </Button>
    </div>
  );
};
